export const constant = {
  outlookAccessToken: "outlook_access_token",
  googleSignedIn: "googleSignedIn",
  refreshToken: "refresh_token",
  responseType: "code",
  responseMode: "query",
  codeVerifier: "code-verifier",
  authCode: "auth-code",
  authorizationCode: "authorization_code",
  authCodeUrl: process.env.REACT_APP_AZURE_AUTH_CODE_URL,
  oauthUrl: process.env.REACT_APP_AZURE_OAUTH_URL,
  codeChallengeMethod: process.env.REACT_APP_AZURE_CODE_CHALLENGE_METHOD,
  baseUrl: process.env.REACT_APP_BASE_URL,
  clientID: process.env.REACT_APP_AZURE_CLIENT_ID,
  authority: process.env.REACT_APP_AZURE_AUTHORITY,
  redirectPath: process.env.REACT_APP_AZURE_REDIRECT_PATH,
  endpoint: process.env.REACT_APP_AZURE_GRAPH_ENDPOINT,
  scope: process.env.REACT_APP_AZURE_SCOPE,
  sessionType: process.env.REACT_APP_AZURE_SESSION_TYPE,
  recoilDuplicateAtomKeyCheckingEnabled:
    process.env.REACT_APP_AZURE_RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED,
  somethingWrong: "Something went wrong",
  add: "Add",
  folderExplorer: "File Explorer",
  statusOption: [
    { label: "New", value: 100, color: "#342EF0" },
    { label: "In review", value: 100, color: "#F68524" },
    { label: "Available", value: 100, color: "#0F8739" },
    { label: "Engaged", value: 100, color: "#F65911" },
    { label: "Offered", value: 100, color: "#6B32CF" },
    { label: "Hired", value: 100, color: "#0F8739" },
    { label: "Rejected", value: 100, color: "#CF1C00" },
  ],
  create: "Create",
  listView: "List View",
  tableView: "Kanban View",
  selectView: "Select View",
  view: "View",
  exportSelectedDataAsCSV: "Export Selected Data as CSV",
  exportAsCSV: "Export as CSV",
  exportSelectedDataAsExcel: "Export Selected Data as Excel",
  exportAsExcel: "Export as Excel",
  manageColumns: "Manage Columns",
  import: "Import",
  noOptionAvailable: "No options available",
  newCustomView: "New custom view",
  filterSelectList: [
    { value: "all", label: "All title" },
    { value: "locked", label: "All locked title" },
    { value: "converted", label: `Converted title` },
    { value: "junk", label: `Junk title` },
    { value: "mailing", label: `Mailing title` },
    { value: "my_converted", label: `My converted title` },
    { value: "my", label: `My title` },
    { value: "not_qualified", label: `Not qualified title` },
    { value: "open", label: `Open title` },
    { value: "recently_created", label: `Recently created title` },
    { value: "recently_modified", label: `Recently modified title` },
    { value: "today", label: `Today title` },
    { value: "unread", label: `Unread title` },
    { value: "unsubscribed", label: `Unsubscribed title` },
  ],
  selectAnOption: "Select an option",
  action: "Actions",
  actionSelectList: [
    { value: "mass_delete", label: `Mass delete` },
    { value: "mass_update", label: `Mass update` },
    { value: "mass_convert", label: `Mass convert` },
    { value: "draft", label: `Draft` },
    { value: "mass_email", label: `Mass email` },
    { value: "autoresponder", label: `Autoresponders` },
    { value: "approve", label: `Approve title` },
    { value: "duplicate", label: `Duplicate title` },
    { value: "add_campaign", label: `Add to campaign` },
    { value: "create_client_script", label: `Create client script` },
    { value: "export", label: `Export title` },
  ],
  filter: "Filter",
  search: "Search",
  selectDate: "Select Date",
  jobOpenings: "Job Openings",
  targetDate: "Target Date",
  targetDateAccessor: "targetDate",
  createJobOpening: "Create Job Opening",
  jobOpening: "Job Opening",
  postingTitle: "Posting Title",
  enterPostingTitle: "Enter Posting Title",
  departmentName: "Department Name",
  enterDepartmentName: "Enter Department Name",
  title: "Title",
  hiringManager: "Hiring Manager",
  assignedRecruiter: "Assigned Recruiter",
  numberOfPosition: "Number of Positions",
  enterNumber: "Enter Number",
  dateOpened: "Date Opened",
  jobOpeningStatus: "Job Opening Status",
  jobType: "Job Type",
  industry: "Industry",
  workExp: "Work Experience",
  salary: "Salary",
  requiredSkills: "Required Skills",
  next: "Next",
  associate: "Associate",
  city: "City",
  state: "State",
  country: "Country",
  zipCode: "Zip Code",
  enterCode: "Enter Code",
  back: "Back",
  jobDescription: "Job Description",
  requirements: "Requirements",
  benefits: "Benefits",
  jobSummary: "Job Summary",
  attachment: "Attachment",
  noFileChoosen: "No file chosen.",
  save: "Save",
  others: "Others",
  chooseJobTemp: "Choose job template",
  update: "Update",
  close: "Close",
  editDepartment: "Edit Department",
  edit: "Edit",
  delete: "Delete",
  share: "Share",
  actions: "Actions",
  selectDepartment: "Select Department",
  selectHiringManager: "Select Hiring Manager",
  selectAssignedRecruiter: "Select Assigned Recruiter",
  enterCity: "Enter City",
  selectState: "Select State",
  fileUploadedSuccessfully: "File uploaded successfully!",
  fileUploadFailed: "File upload failed",
  somethingWentWrong: "Something went wrong",
  uploadFailed: "Upload failed",
  failedToLoadDepartments: "Failed to load departments",
  notAllowed: "N/A",
  jobOpeningCreatedSuccess: "Job Opening Created successfully!",
  failedToAddProfile: "Failed to add profile",
  apiReqFailed: "API request failed",
  failedToLoadUser: "Failed to load users",
  candidateStage: "Candidate Stage",
  candidateName: "Candidate Name",
  createCandidate: "Candidate",
  offerLetter: "Offer Letter",
  modifyTime: "Modify Time",
  source: "Source",
  candidateOwner: "Candidate Owner",
  rating: "Rating",
  upload: "Update",
  actionAll: "All",
  contacted: "Contacted",
  applyFilterBtn: "Apply Filter",
  allSelectOptions: [
    { value: "cold_lead", label: `Cold Lead` },
    { value: "advertisement", label: `Advertisement` },
    { value: "web_download", label: `Web Download` },
    { value: "online", label: `Online` },
  ],
  langugageSelector: {
    english: "English",
    hindi: "Hindi",
    en: "en",
    hi: "hi",
  },
  invalidDate: "Invalid Date",
  status: "Status",
  statusAccessor: "status",
  postingTitleAccessor: "title",
  assignedRecruiterAccessor: "assignedRecruiter",
  department: "Department",
  departmentAccessor: "department",
  hiringManagerAccessor: "hiringManager",
  editJobProfile: "Edit Job Profile",
  name: "Manage360",
  editJobOpening: "Edit Job Opening",
  something_went_wrong: "Something went wrong",
  interview: "Interview",
  createInterview: "Create Interview",
  editInterview: "Edit Interview",
  interviewName: "Interview name",
  interviewer: "Interviewer",
  scheduleDateTime: "Schedule Date And Time",
  interviewRound: "Interview Round",
  commentForInterviewer: "Comment for Interviewer",
  commentForCandidate: "Comment for Candidate",
  candidate: "Candidate",
  round: "Round",
  interviewType: "Interview Type",
  jobTitle: "Job Title",
  candidateEmail: "Candidate Email",
  candidatePhoneNo: "Candidate Phone Number",
  jobProfile: "Job Profile",
  namePlaceHolder: "Enter Name",
  nameLabel: "Name",
  emailPLaceHolder: "Enter email",
  emailLabel: "Email",
  phoneLabel: "Phone",
  phonePlaceHolder: "Enter Phone",
  locationLabel: "Location",
  totalExperience: "Total experience",
  currentLOcationLabel: "Current Location",
  currentLocation: "Enter current location ",
  noticePeriod: "Notice period",
  applicationSource: "Application source",
  CoverLetter: "Cover Letter",
  requiredTitle: "Title is required",
  requiredDepartment: "Department is required",
  requiredHiringManager: "Hiring Manager is required",
  requiredAssignedRecruiter: "Assigned Recruiter is required",
  requiredIndustry: "Industry is required",
  requiredSalary: "Salary is required",
  requiredDescription: "Description is required",
  requiredRequirements: "Requirements are required",
  requiredBenefits: "Benefits are required",
  selectInterviewer: "Select Interviewer",
  selectRound: "Select Round",
  selectInterviewType: "Select Interview Type",
  selectCandidate: "Select Candidate",
  advanceSearch: " Advance Search",
  jobApplicationTitle: "Job Application",
  jobApplication: "JobApplication",
  createJobApplication: "Create Job Application",
  editJobApplication: "Edit Application",
  currentLocationLabel: "Current Location",
  date: "Date",
  applicationId: "Application Id",
  createApplication: "Create Application",
  candidateDetail: "Candidate detail",
  selectTitle: "Select Title",
  job: "Job",
  enterLocation: "Enter Location",
  totalExp: "Total Experience",
  selectTotalExp: "Select Total Experience",
  selectCurrentLocation: "Select Current Location",
  enterNoticePerios: "Enter Notice Period",
  selectStatus: "Select Status",
  selectApplicationSource: "Select Application Source",
  selectJob: "Select Job",
  requiredJob: "Job is required",
  requiredName: "Name is required",
  requiredPhone: "Phone is required",
  requiredLocation: "Location is required",
  applicationName: "Application Name",
  remindBefore: "Remind Before",
  remindBeforePlaceholder: "Enter Remind Before",
  reminderOptionSelect: "Select Reminder Option",
  reminderOption: "Reminder Option",
  notifyCandidate: "Notify candidate",
  setReminder: "Set Reminder",
  startOn: "Start On",
  startTime: "Start Time",
  selectTime: "Select Time",
  pending: "Pending",
  withdraw: "Withdraw",
  accept: "Accept",
  expired: "Expired",
  decline: "Decline",
  draft: "Draft",
  createCall: "Create Call",
  emailSend: "EmailSend",
  createOfferLetter: "Create Offer Letter",
  jobapplicant: "Job Applicant",
  offerExpireOn: "Offer Expire On",
  expectedJoiningDate: "Expected Joining Date",
  rate: "Rate",
  description: "Description",
  selectSalaryComponents: "Select Salary Components",
  salaryStructure: "Salary Structure",
  annualCTC: "Annual CTC",
  basicSalary: "Basic Salary",
  specialAllowance: "Special Allowance",
  basicValueType: "Basic Value Type",
  grossSalary: "Gross Salary",
  signaturerequired: "Signature Required",
  addSalaryStructure: "Add Salary Structure",
  fixed: "Fixed",
  percentage: "Percentage",
  salaryValue: 100,
  salaryComponent: "Salary Component",
  calculationType: "Calculation Type",
  MonthlyAmount: "Monthly Amount",
  Annualamount: "Annual Amount",
  statistics: "Statistics",
  leadStatistics: "Lead Statistics",
  totalLeads: "Total Leads",
  newLeads: "New Leads",
  contactedLeads: "Contacted Leads",
  qualifiedLeads: "Qualified Leads",
  new: "new",
  newValue: "New",
  contactedValue: "contacted",
  qualifiedValue: "Qualified",
  qualified: "qualified",
  taskStatics: " Task Statistics",
  totalTask: "Total Tasks",
  firstName: "First Name",
  lastName: "Last Name",
  phoneNumber: "Phone Number",
  userEmail: "User Email",
  welcomeTo: "Welcome to",
  manage360: "Manage360",
  CRM: "CRM",
  CRMDesc:
    "CRM enables contact management, sales, leads, email, analytics, reports, automation, support.",
  vault: "Vault",
  vaultDesc:
    "Vault password secures encrypted data, credentials, and info from threats.",
  recruitment: "Recruitment",
  recruitmentDesc:
    "Recruiting involves attracting, screening, and hiring candidates for jobs. It ensures organizations find skilled talent to meet workforce needs efficiently.",
  userName: "User Name",
  password: "Password",
  checkbox: "Checkbox",
  permission: "Permission",
  manage: "Manage",
  select: "Select",
  createDepartment: "Create Department",
  enterJobOpening: "Enter Job Opening",
  departments: "Departments",
  enterDescription: "Enter Description",
  taskTitle: "Title",
  taskRelatedTo: "Related To",
  taskStart: "Start Date",
  taskEnd: "End Date",
  taskLink: "Link",
  taskReminder: "Reminder",
  assignmentTo: "Assign To",
  assignedTo: "Assigned To",
  taskCreateBy: "Created By",
  taskDescription: "Description",
  taskNotes: "Notes",
  uploadFiles: "Upload Files",
  uploadFilesDesc:
    "Accepted File Types (Images, PDFs, Word docs, Powerpoint, Excel, ZIP, and video files - 15MB max)",
  sender: "Sender",
  recipent: "Recipient",
  createdTo: "Create to",
  recipentName: "Recipient Name",
  recipentPhoneNumber: "Recipient Phone Number",
  relatedTo: "Related To",
  startDate: "Start Date",
  endDate: "End Date",
  send: "Send",
  timestamp: "Timestamp",
  callDuration: "Call Duration",
  callNotes: "Call Notes",
  referrals: "Referrals",
  roles: "Roles",
  referralUrl: "referrals",
  mypassword: "my-password",
  deleteDesc: "Are you sure you want to delete selected",
  subject: "Subject",
  message: "Message",
  sendEmail: "Send Email",
  accountErrorMsg: "Please select account",
  dealErrorMsg: "Please select deal",
  fileName: "File Name",
  folderName: "Folder Name",
  selectInterestedProperty: "Select Interested Product",
  uploadTitle: "Upload",
  uploadDesc: "Accepted File Types (Images files - 5MB max) only 10 files",
  pleaseSelect: "Please Select",
  selectedFiles: "Selected Files",
  assignToContact: "Assign To Contact",
  assignToAccount: "Assign To Account",
  assignToLead: "Assign To Lead",
  bgcolor: "Background-Color",
  assignToDeal: "Assign To Deal",
  deal: "Deal",
  borderolor: "Border-Color",
  textColor: "Text-Color",
  url: "URL",
  notes: "Notes",
  uploadResume: "Upload Resume",
  robRecommendation: " Job Recommendation",
  referringForJob: "Referring For Job",
  email: "Email",
  currentJobTitle: "Current Job Title ",
  currentEmployer: "Current Employer",
  submitReferral: " Submit",
  cancel: "Cancel",
  referAcandidate: "Refer a candidate",
  none: "None",
  contact: "Contact",
  lead: "Lead",
  account: "Account",
  accounts: "Accounts",
  deals: "Deals",
  campgain: "Campgain",
  createCampgain: "Create Campgain",
  emailViewPage: "View page",
  to: "To",
  from: "From",
  body: "Body",
  deleteJobAllication: "Deleted successfully",
  selectToRead: "Select an item to read",
  nothingSelected: "Nothing is selected",
  passwordViewPage: "Password View Page",
  createMeeting: "Create Meeting",
  meetingDetails: "Meeting Details",
  callDetails: "Call Details",
  details: "Details",
  createContact: "Create Contact",
  createEmail: "Create Email",
  createLead: "Create Lead",
  createProperty: "Create Product",
  addPassword: "Add Password",
  readOnly: "Read Only",
  readAndWrite: "Read & Write",
  manageAccess: "manage",
  copied: "Copied!",
  viewPassword: "View Password",
  jobOpeningID: "Job Opening ID",
  jobOpeningId: "jobOpeningId",
  campaign: "Campaign",
  createCampaign: "Create Campaign",
  campaignOwner: "Campaign owner",
  type: "Type",
  campaignName: "Campaign name",
  expectedRevenue: "Expected revenue",
  budgetCost: "Budget cost",
  actualCost: "Actual cost",
  expectedResponse: " Expected response",
  numberSent: "Number sent",
  deleteMsg: "Deleted successfully",
  departmentID: "Department ID",
  departmentDeleteMsg: "Deleted successfully",
  viewLabels: {
    contact: "contactView",
    lead: "leadView",
  },
  dateAndTime: "Date & Time",
  enterPassword: "Enter Password",
  changeAccess: "Change Access",
  confirmPassword: "Confirm Password",
  enterUserName: "Enter Username",
  createUser: "Create User",
  user: "User",
  editPermission: "Edit Permission",
  notStarted: "Not Started",
  inProgress: "In Progress",
  completed: "Completed",
  deleteSingleDesc: "Are you sure you want to delete this",
  selectModule: "Select Module",
  fields: "Fields",
  showMore: "Show more",
  showLess: "Show less",
  addNew: "Add New",
  yes: "Yes",
  no: "No",
  notDefined: "not_defined",
  cc: "cc",
  enterEmailAddress: "Enter Email Address",
  defaultTitle: "default-title",
  addField: "Add Field",
  addNote: "Add Note",
  roleAccess: "role-access",
  newAccount: "Sync Account",
  emailDesc: "Grant access to calendar and email to your workspac",
  chooseProvider: "Choose your provider",
  connectGoogle: "Connect with Google",
  connectOutlook: "Connect with Outlook",
  calendar: "Calendar",
  remarksSuccess: "Note added successfully",
  superAdmin: "superAdmin",
  selectContacts: " Select Contacts from",
  passwordChange: "Password changed successfully.",
  loginAgain: "Please log in again.",
  oldPassword: " Old Password",
  changePassword: "Change Password",
  newPassword: "New Password",
  confirmNewPassword: "Confirm New Password",
  selctAccounts: "Select Account",
  termCondition:
    "By using Manage360, you agree to the Terms of Service and Privacy Policy",
  welcomeText: "Welcome to Manage360",
  googleSignin: "Sign in with Google",
  fbSignin: "Sign in with Facebook",
  outlookLogin: "Sign in with Outlook",
  whatsUpdate: "What’s the update?",
  shareProposal: "Please share the proposal.",
  cannotAddSameEmail: "Cannot add the same email more than once",
  uploadImageTitle: "Upload",
  successOnboard: "Onboarding Complete!",
  successOnboardDesc: "You’re all set to start using the platform.",
  attactments: "Attachments",
  Login: "Login",
  resetPassword: "Reset Password",
  shareViaEmail: "Share Via Email",
  shareManually: "Share Password Manually",
  generatePassword: "Generate Password",
  getStartedNow: "Get Started Now",
  getStartedDesc: "Enter your credentials to access your account",
  donotHaveAccount: "Don’t have an account?",
  signUp: "Sign up",
  forgotPassword: "Forgot Password?",
  remember: "Remember",
  getStarted: "Get Started",
  completeSteps: "Completed All the following steps",
  step1: {
    title: "Create your workspace",
    description:
      "A shared work environment where you will be able to manage your customer relations with your team.",
    logoLabel: "Workspace logo",
    logoSupportText: "We support your square PNGs, JPEGs and GIFs under 10MB",
    nameLabel: "Workspace name",
    nameDescription: "The name of your organization",
    continueButton: "Continue",
  },
  step2: {
    title: "Create Profile",
    description: "How you'll be identified on the app.",
    pictureLabel: "Picture",
    pictureSupportText:
      "We support your square PNGs, JPEGs and GIFs under 10MB",
    nameLabel: "Name",
    nameDescription: "Your name as it will be displayed on the app",
    continueButton: "Continue",
  },
  step3: {
    title: "Email and Calendar",
    description:
      "Sync your emails and calendar to collaborate better with your team.",
    options: {
      everything: {
        title: "Everything",
        description:
          "Your emails and events content will be shared with your team.",
      },
      subjectMetadata: {
        title: "Subject and metadata",
        description:
          "Your email subjects and meeting titles will be shared with your team.",
      },
      metadata: {
        title: "Metadata",
        description:
          "Only the timestamp and participants will be shared with your team.",
      },
    },
    syncGoogle: "Sync with Google",
    syncOutlook: "Sync with Outlook",
    continueWithoutSync: "Continue without sync",
  },
  step4: {
    title: "Invite your team",
    description: "Get the most out of your workspace by inviting your team.",
    orText: "or",
    copyInvite: "Copy invitation link",
    continueButton: "Continue",
    skipButton: "Skip",
  },
  taskStatus: "Task status updated!",
  failedTaskStatus: "Failed to update task status.",
  Setup: "Setup",
  currency: "Currency",
  currencySettings: "Currency Configuration",
  currencyDetails: "Set your preferred currency for transactions, reports, and client communications.",
  selectCurrency: "Select Currency",
  codeSymbol: "Code/Symbol",
  digitSeparators: "Digit Separators",
  decimalPlaces: "Decimal Places",
  setCurrency: "Set Currency",
  createOrganization: "Create Your Organization",
  createOrganizationDesc: "Collaborate with your team to manage customer relations.",
  saveContinue: "Save & Continue",
  syncEmailAndCalendar: "Sync Emails & Calendar",
  syncGoogle: " Sync with Google",
  syncOutlook: "Sync with Outlook",
  inviteTeam: "Invite Your Team",
  setPssword: "Set your password",
  signUpText: "Sign Up",
  signUpDesc: "Collaborate with your team to manage customer relations.",
  organizationLogo: "Organization Logo",
  logoSupportText: "We support your square PNGs, JPEGs and GIFs under 10MB",
  organization: "Organization",
  nameOfOrganization: "The name of your organization",
  companyName: "Company Name",
  googleSync: "Google",
  microsoftSync: "Microsoft",
  enterEmail: "Enter Email",
  activateRule: "Activate this Rule",
  ruleExecuted: " This rule will be executed when the",
  when: "When",
  modulesMatching: "Modules matching certain conditions",
  allModules: "All Modules",
  emailNotification: "Email Template",
  newEmailNotification: "New Email Template",
  confirmStatus:"Confirm Status",
  confirmStatusDesc: "Are you sure you want to change the status?",
  confirm:"Confirm",
};
export const priorityLabelMap = {
  not_defined: "Not Defined",
  low: "Low",
  medium: "Medium",
  high: "High",
  highest: "Highest",
};

export const createWorkspaceOptions = [
  { id: 1, label: "Sign Up", description: "Sync your Emails and Calendar with Twenty. Choose your privacy settings." },
  { id: 2, label: "Create your Organization", description: "Collaborate with your team to manage customer relations." },
  { id: 3, label: "Email & Calendar", description: "Sync your Emails and Calendar with Twenty. Choose your privacy settings." },
  { id: 4, label: "Invite Your Team", description: "Get the most out of your workspace by inviting your team." },
];
export const createRuleFields = [
  {
    key: "module",
    label: "Module Name",
    type: "select",
    options: [
      { value: "leads", label: "Leads" },
      { value: "contacts", label: "Contacts" },
      { value: "accounts", label: "Accounts" },
      { value: "deals", label: "Deals" },
      { value: "Tasks", label: "Tasks" },
      { value: "Meetings", label: "Meetings" },
      { value: "Calls", label: "Calls" },
    ],
  },
  {
    key: "ruleName",
    label: "Rule Name",
    type: "text",
    placeholder: "Enter rule name",
    validation: {
      required: true,
      maxLength: 30,
    },
  },
  {
    key: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Enter description",
    validation: {
      required: true,
      maxLength: 150,
    },
  },
];
export const createTaskRuleFields = [

  {
    key: "title",
    label: "Title",
    type: "text",
    placeholder: "Enter title",
    validation: {
      required: true,
      maxLength: 30,
    },
  },
  {
    key: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Enter description",
    validation: {
      required: true,
      maxLength: 150,
    },
  },
  {
    key: "assignedTo",
    label: "Assign To User",
    type: "select",
    options: [],
    placeholder: "Select user",
  },
  {
    key: "priority",
    label: "Priority",
    type: "select",
    options: [

      { label: "Low", value: "low" },
      { label: "Medium", value: "medium" },
      { label: "High", value: "high" },
      { label: "Highest", value: "highest" },
    ],
    validation: { required: true },
  },
  {
    key: "dueDate",
    label: "Due Date",
    type: "datetime-local",
    placeholder: "Select due date",
    validation: { required: true },
  },
];

export const workflowOptions = {
  eventOptions: [
    { value: "create", label: "Created" },
    { value: "edit", label: "Edited" },
    { value: "create_or_edit", label: "Created or Edited" },
    { value: "delete", label: "Deleted" },
    { value: "scheduled", label: "On Schedule" }
  ],
  operatorOptions: [
    { value: "=", label: "Equals" },
    { value: "!=", label: "Not Equals" },
    { value: ">", label: "Greater Than" },
    { value: "<", label: "Less Than" },
    { value: ">=", label: "Greater Than or Equal" },
    { value: "<=", label: "Less Than or Equal" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Does Not Contain" },
    { value: "starts_with", label: "Starts With" },
    { value: "ends_with", label: "Ends With" },
    { value: "is_empty", label: "Is Empty" },
    { value: "is_not_empty", label: "Is Not Empty" },
  ],
  actionValue: [
    { value: "emailNotification", label: "Email Notification" },
    { value: "task", label: "Task" },
    { value: "setValue", label: "Set a Value" },
  ]
};
export const createNewTemplateFields = [
  {
    key: "name",
    label: "Name",
    type: "text",
    placeholder: "Enter name",
  },
  {
    key: "sendTo",
    label: "To",
    type: "select",
    options: [
      { value: "owner", label: "Owner" },
      { value: "manager", label: "Manager" },
    ],
  },
  {
    key: "template",
    label: "Email Template",
    type: "select",
    options: [],
    placeholder: "Select template",
  },
  {
    key: "massEmail",
    label: "Send this notification as a single mass Email with all recipients displayed",
    type: "checkbox",
    validation: { required: false },
  },
];